import React from 'react';
import FlowForm from '@components/Flow/FlowForm/FlowForm';
import OfferPage from '@pages/offers/OfferPage/OfferPage';

const View = ({ data: { loading, offer, showAlert }, stream, handleSubmit, ...rest }) => {
  return stream.offerId ? (
    <OfferPage offerId={stream.offerId} editFlow>
      <FlowForm
        loading={loading}
        stream={stream}
        onSubmit={handleSubmit}
        offer={offer}
        showAlert={showAlert}
      />
    </OfferPage>
  ) : null;
};

export default View;
